module.exports = __webpack_public_path__ + "static/media/jun1.92767959.jpg";